import client from '../api-client';
import { getBaseDeleteUrlByNetwork } from './getBaseUrlByNetwork';

export default async function deleteConnection({ APIBaseURL, networkType, hash }) {
  const baseUrl = getBaseDeleteUrlByNetwork(APIBaseURL, networkType);
  const url = `${baseUrl}/${hash}`;

  try {
    const response = await client(url, { method: 'DELETE' });
    return response ?? {};
  } catch ({ message }) {
    // eslint-disable-next-line no-console
    console.warn(message);
    return { error: { message } };
  }
}
